import axios, { AxiosPromise, AxiosResponse } from 'axios';
import {
  ExamTaskGroupSolutionsProgressData,
  ExamTaskGroupSolutionPerExaminers,
  DownloadType,
} from '../../pages/Assessment/Assessment.types';
import { DownloadExamTaskGroupSolution } from '../../models/assessment.types';
import EnvWindow from '../../utils/env';
import {
  AssessmentSessionProcessTypeId,
  ExamTaskGroupSolutionStatus,
} from '../exams/assessmentSession/assessments.types';

export async function getTaskGroupSolutionProgress(
  assessmentSessionId: string,
  examinerIds: string[],
): Promise<AxiosResponse<ExamTaskGroupSolutionsProgressData>> {
  const examinerIdsQuery = examinerIds.map((id: string) => `examinerIds=${id}`).join('&');
  return await axios.get(
    `${EnvWindow.REACT_APP_DISTRIBUTION__EXAM_TASK_GROUP_SOLUTION_API_URL}/${assessmentSessionId}/progress?${examinerIdsQuery}`,
  );
}

export async function filterExamTaskGroupSolutionPerExaminers(
  assessmentSessionId: string,
  examinerIds: string[],
): Promise<AxiosResponse<ExamTaskGroupSolutionPerExaminers>> {
  const examinerIdsQuery = examinerIds.map((id: string) => `examinerIds=${id}`).join('&');
  return await axios.get(
    `${EnvWindow.REACT_APP_DISTRIBUTION__EXAM_TASK_GROUP_SOLUTION_API_URL}/${assessmentSessionId}/FilterExamTaskGroupSolutionPerExaminers?${examinerIdsQuery}`,
  );
}

export async function downloadExamTaskGroupSolution(
  assessmentSessionProcessType: AssessmentSessionProcessTypeId,
  downloadType: DownloadType,
  assessmentSessionId: string,
  examinerId: string,
): Promise<DownloadExamTaskGroupSolution> {
  const response = await axios.post(`${EnvWindow.REACT_APP_DISTRIBUTION__EXAM_TASK_GROUP_SOLUTION_API_URL}`, {
    assessmentSessionProcessType,
    downloadType,
    assessmentSessionId,
    examinerId,
  });
  return response.data;
}

export function getExamTaskGroupSolutionStatus(
  processType: AssessmentSessionProcessTypeId,
): AxiosPromise<ExamTaskGroupSolutionStatus> {

  const result = axios.get(
    `${EnvWindow.REACT_APP_DISTRIBUTION__EXAM_TASK_GROUP_SOLUTION_API_URL}/assessmentsessionprocesstype/${processType}/examtaskgroupsolutionstatus`,
  );
  return result;
}

export function checkIfAssessmentStarted(
  examTaskGroupIds: string[],
): AxiosPromise<{ examinersStartedAssessment: boolean }> {
  return axios.get(
    `${EnvWindow.REACT_APP_DISTRIBUTION__EXAM_TASK_GROUP_API_URL}/AssessmentStarted?${examTaskGroupIds
      .map((id: string) => `examTaskGroupIds=${id}`)
      .join('&')}`,
  );
}
